module.exports = __webpack_public_path__ + "static/media/ministry-of-finance.d44d2dbe.png";